<template>
  <div>
    <h3 class="ts-text-xs ts-uppercase ts-text-blue-700">{{ $t('employeeProfile.addressContact') }}</h3>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-6 ts-space-y-4">
          <div class="row">
            <label
              class="required col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.phone') }}</label>
            <div class="col-md-7">
              <input v-model="model.phone" type="text" class="form-control" />
              <div class="validate" v-if="errors.has('phone')">{{ errors.first('phone') }}</div>
            </div>
          </div>

          <div class="row">
            <label class="col-md-4 form-col-label control-label">{{ $t('employeeProfile.email') }}</label>
            <div class="col-md-7">
              <input v-model="model.email" type="email" class="form-control" />
              <div class="validate" v-if="errors.has('email')">{{ errors.first('email') }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 ts-space-y-4">
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.address') }}</label>
            <div class="col-md-7">
              <textarea v-model="model.address" rows="4" class="form-control"></textarea>
              <div class="validate" v-if="errors.has('address')">{{ errors.first('address') }}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'addressAndContact',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>